module.exports = __webpack_public_path__ + "img/internet.36bbae88.svg";